import React from "react";
import { List, Datagrid, ReferenceField, FunctionField } from "react-admin";
import RideFilter from "./RideFilter";
import CompanyField from "../components/fields/CompanyField";
import { DestinationField, OriginField } from "../components/fields/RideFields";

export default (props) => (
  <List
    title="Rides"
    {...props}
    perPage={25}
    filters={<RideFilter />}
    bulkActionButtons={false}>
    <Datagrid>
      <ReferenceField
        label="Company"
        source="companyId"
        reference="admin/companies"
        linkType={false}>
        <FunctionField render={CompanyField} />
      </ReferenceField>
      <FunctionField render={OriginField} label="from" />
      <FunctionField render={DestinationField} label="to" />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/rides/RidesList.js